import {UseQueryOptions, useQuery} from '@tanstack/react-query'
import {useGetCalendarApiMethod} from 'api/useGetCalendarApiMethod'
import {zip} from 'lodash'
import {Params, Ventrata} from 'types'

export const useGetCalendarQuery = (
  params: Omit<Params.GetCalendar, 'optionId'> & {optionIds: string[]},
  options?: Omit<UseQueryOptions<Ventrata.CalendarDay[][]>, 'queryKey' | 'queryFn'>
) => {
  const getCalendar = useGetCalendarApiMethod()

  return useQuery({
    queryKey: ['getCalendar', params],
    queryFn: async () => {
      const calendars = await Promise.all(params.optionIds.map((optionId) => getCalendar({...params, optionId})))

      return zip(...calendars) as Ventrata.CalendarDay[][]
    },
    ...options,
  })
}
